import { FC } from 'react';
import CopyMenuItem from './copy-menu-item';

const CopyUrlMenuItem: FC = () => {
  return <CopyMenuItem value={window.location.href} label="Copy URL" icon="link" />;
};

export default CopyUrlMenuItem;
